<template>
  <form @submit.prevent="login" class="mb-3">
    <p v-if="this.error.message.length" class="error-message">
      {{ this.error.message }}
    </p>
    <div class="form-controls-wrap">
      <div class="form-control-icon-wrap">
        <div class="input-field-floating">
          <b-form-input
            class="input-field-floating"
            :class="{
              'error-input': this.error.passwordMessage.length,
              'valid-input': !this.error.passwordMessage.length && userEmail
            }"
            v-model="userEmail"
            placeholder=""
            v-validate="'required|email'"
            data-vv-validate-on="none"
            name="email"
            data-vv-as="Email"
            disabled
          ></b-form-input>
          <label>{{ $t("email") }}</label>
        </div>
        <div v-if="errors.has('step1.email')" class="invalid-field">
          {{ errors.first("step1.email") }}
        </div>
        <div v-if="error.message" class="invalid-field ">
          {{ error.message }}
        </div>
      </div>
    </div>
    <div class="form-controls-wrap mt-4">
      <div class="form-control-icon-wrap">
        <div class="input-field-floating">
          <b-form-input
            class="input-field-floating"
            :class="{
              'error-input': passwordErrors,
              'valid-input':
                !passwordErrors && credentials.password
            }"
            type="password"
            v-model="credentials.password"
            placeholder=""
            v-validate="'required|min:6'"
            data-vv-validate-on="none"
            name="password"
            :data-vv-as="$t('password')"
            @focus="clearErrorMessage('passwordMessage')"
            @input="clearErrorMessage('passwordMessage')"
            ref="password"
          ></b-form-input>
          <label> {{ $t("password") }}</label>
          <img
            v-if="credentials.password && credentials.password.length"
            class="delete-inputed"
            :src="`${publicPath}assets/images/svg/delete.svg`"
            alt="delete"
            @click="credentials.password = ''"
          />
        </div>
        <div v-if="errors.has('step2.password')" class="invalid-field">
          {{ errors.first("step2.password") }}
        </div>
      </div>
    </div>
    <p v-if="this.error.passwordMessage.length" class="error-message mt-2 ml-4 mb-0">
      {{ this.error.passwordMessage }}
    </p>
    <div class="btn-step-next-wrap" style="display: inline-block;">
      <b-button
        type="submit"
        variant="yellow"
        block
        class="btn-step-next"
        :disabled="isDisabled"
        >{{ $t("continue") }}</b-button
      >
    </div>
  </form>
</template>

<script>
import crypto from "crypto";
import i18n from "../../i18n";

export default {
  name: "LoginWithEmail",
  data() {
    return {
      credentials: {
        email: "".toLowerCase(),
        password: "",
        rememberIsChecked: true
      },
      error: {
        code: null,
        password: "",
        passwordMessage: "",
        message: "",
        log: "",
        title: "",
        response: {}
      },
      // eslint-disable-next-line no-control-regex
      regex: /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
    };
  },
  props: {
    userEmail: {
      type: String,
      default: ""
    },
    userPass: {
      type: String,
      default: ""
    }
  },
  computed: {
    isDisabled() {
      return this.credentials.password.length < 6;
    },
    passwordErrors() {
      return this.error.password.length || this.error.passwordMessage.length;
    }
  },
  methods: {
    login() {
      if (this.isDisabled) return;
      this.credentials.email = this.userEmail;
      const newPass = crypto
        .createHash("md5")
        .update(this.credentials.password)
        .digest("hex");

      if (!this.credentials.password) {
        this.error.passwordMessage = i18n.t("enter-password");
        return;
      }

      if (this.credentials.password.length < 6) {
        this.error.passwordMessage = i18n.t("password-too-short");
        return;
      }

      if (newPass !== this.userPass) {
        this.error.passwordMessage = i18n.t("passwordMessage");
        return;
      }

      const validEmail = this.regex.test(this.credentials.email);
      if (!validEmail) {
        this.error.emailMessage = i18n.t("error-valid-mail");
        return;
      }

      this.$router
        .push({
          name: "DeleteAccount",
          query: this.$route.query
        })
        .catch(() => {});
    },
//     /*
//    show hide password
//  */
//     showHide() {
//       // eslint-disable-next-line no-unused-expressions
//       this.showHidePassword = !this.showHidePassword;
//       // eslint-disable-next-line no-unused-expressions
//       this.showHidePassword
//         ? (this.passwordInputType = "text")
//         : (this.passwordInputType = "password");
//     },
    firstLetterLowerCase() {
      this.credentials.email = this.credentials.email.toLowerCase();
    },
    clearErrorMessage(type) {
      if (this.credentials.email) {
        this.firstLetterLowerCase();
      }
      if (type === "emailMessage") {
        this.error.emailMessage = "";
        this.error.message = "";
        return;
      }
      this.error.passwordMessage = "";
      this.error.message = "";
    }
  }
};
</script>
<!-- 
<style scoped>
.form-group {
  /* padding: 10px; */
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-sizing: border-box;
  border-radius: 4px;

  margin: 25px 0;
  position: relative;
}
.form-group > label {
  position: absolute;
  top: -6px;
  left: 20px;
  color: #a7afbd;
  background-color: #202020;
  padding-left: 5px;
  padding-right: 5px;
  font-family: Roboto;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
  text-align: left;
}
.form-group:focus-within {
  border: 1px solid #ffff00;
}
.form-group:focus-within label {
  color: #ffff00;
}
.form-group > input {
  border: none;
  background-color: unset;
  color: #585858;
  font-size: 16px;
  font-family: Gotham;
  text-decoration: underline;
}
.form-group > input:focus,
:focus-visible {
  box-shadow: unset;
  outline: unset !important;
  background-color: unset;
  color: #585858;
}

.password {
  width: 90%;
  height: 100%;
  background: unset;
  border: unset;
  color: #585858;
}
.password:focus-visible {
  box-shadow: unset !important;
  background-color: unset !important;
}
.password:focus {
  border: unset !important;
  outline: unset;
  box-shadow: unset;
}

.form-control {
  border: unset;
}
.error-field {
  margin-bottom: 0;
}
.error-field label {
  color: #e74c3c;
}
</style> -->
